// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ekans: PokeData = {
  "id": 23,
  "name": "ekans",
  "height": 20,
  "weight": 69,
  "base_experience": 58,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "slam",
    "wrap",
    "poison-sting",
    "leer",
    "bite",
    "acid",
    "toxic",
    "screech",
    "haze",
    "glare",
    "sludge-bomb",
    "stockpile",
    "spit-up",
    "swallow",
    "gastro-acid",
    "poison-jab",
    "mud-bomb",
    "gunk-shot",
    "coil",
    "acid-spray",
    "belch"
  ],
  "moves": [
    "leer",
    "bite",
    "acid",
    "sludge-bomb",
    "poison-jab",
    "mud-bomb",
    "toxic-overload",
    "poison-gas",
    "stun-spore",
    "acid-rain",
    "poison-powder",
    "venom-drench",
    "poison-fang"
  ],
  "evolution_chain": {
    "id": 9,
    "item": null,
    "species": [
      {
        "name": "ekans",
        "order": 23,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arbok",
        "order": 24,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 23,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42,
    "speed": 55,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
